import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export type StatusKind = "todo" | "ok" | "rej" | "exp";

function statusLabelKey(s: StatusKind) {
  switch (s) {
    case "todo":
      return "common.status.todo.label" as const;
    case "ok":
      return "common.status.ok.label" as const;
    case "rej":
      return "common.status.rej.label" as const;
    case "exp":
      return "common.status.exp.label" as const;
  }
}

const DOT_VAR: Record<StatusKind, string> = {
  todo: "--st-todo-bg",
  ok: "--st-ok-bg",
  rej: "--vroom-red",
  exp: "--st-exp-bg",
};

const HALO_VAR: Record<StatusKind, string> = {
  todo: "--st-todo-halo",
  ok: "--st-ok-halo",
  rej: "--st-rej-halo",
  exp: "--st-exp-halo",
};

const TEXT_CLASS: Record<StatusKind, string> = {
  todo: "text-st-todo-fg",
  ok: "text-st-ok-fg",
  rej: "text-st-rej-fg",
  exp: "text-st-exp-fg",
};

export interface StatusBadgeProps {
  status: StatusKind;
  label?: string;
  className?: string;
}

export function StatusBadge({ status, label, className }: StatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 text-xs font-medium",
        TEXT_CLASS[status],
        className,
      )}
    >
      <span
        aria-hidden
        className="inline-block size-2 rounded-full"
        style={{
          background: `var(${DOT_VAR[status]})`,
          boxShadow: `0 0 0 3px var(${HALO_VAR[status]})`,
        }}
      />
      <span>{label ?? t(statusLabelKey(status))}</span>
    </span>
  );
}
